import {isFeatureEnabled} from '@github-ui/feature-flags'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'

import {BoomTown} from './routes/BoomTown'
import {Home} from './routes/home/Index'
import {ShowPage} from './routes/ShowPage'
import {ThankYouPage} from './routes/ThankYouPage'
import EventsUniverseRecapIndex from './routes/events/universe/recap/Index'
import FeaturesCopilotIndex from './routes/features/copilot/Index'
import FeaturesCopilotPlansIndex from './routes/features/copilot/plans/Index'
import SecurityPlansIndex from './routes/security/plans/Index'
import {GitHubAppGAPage} from './routes/features/ai/github-app/Index'

registerNavigatorApp('landing-pages', () => {
  const copilotConsolidationPageEnabled = isFeatureEnabled('site_copilot_consolidation_page')

  return {
    App,
    routes: [
      jsonRoute({path: '/contact-sales/thank-you', Component: ThankYouPage}),
      jsonRoute({path: '/enterprise/contact/thanks', Component: ThankYouPage}),
      jsonRoute({path: '/events/universe/recap', Component: EventsUniverseRecapIndex}),
      jsonRoute({path: '/features/ai/github-app', Component: GitHubAppGAPage}),
      jsonRoute({
        path: '/features/copilot',
        Component: copilotConsolidationPageEnabled ? FeaturesCopilotIndex : ShowPage,
      }),
      jsonRoute({path: '/features/copilot/plans', Component: FeaturesCopilotPlansIndex}),
      jsonRoute({path: '/home', Component: Home}),
      jsonRoute({path: '/security/plans', Component: SecurityPlansIndex}),

      /**
       * We use this route to exercise error handling and exception reporting.
       * in the app. The BoomTown component simply throws an error when it renders.
       */
      jsonRoute({path: '/contentful-lp-tests/boomtown', Component: BoomTown}),

      jsonRoute({path: '*', Component: ShowPage}),
    ],
  }
})
